import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CLINIC, waLink, telLink } from "@/lib/clinic";

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Desktop: floating right column */}
      <div className="hidden md:flex flex-col gap-3 fixed right-5 bottom-6 z-40">
        <a
          href={waLink("Hello Aarogya Clinic, I would like to know more.")}
          target="_blank" rel="noreferrer"
          className="h-13 w-13 h-14 w-14 rounded-full grid place-items-center text-white shadow-lg aarogya-shadow-lg hover:scale-105 transition"
          style={{ background: "#25D366" }}
          data-testid="fab-whatsapp"
          aria-label="WhatsApp"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
        <a
          href={telLink()}
          className="h-14 w-14 rounded-full grid place-items-center text-white shadow-lg aarogya-shadow-lg hover:scale-105 transition"
          style={{ background: "#0A6EBD" }}
          data-testid="fab-call"
          aria-label="Call clinic"
        >
          <Phone className="h-6 w-6" />
        </a>
        {showTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="h-11 w-11 rounded-full grid place-items-center bg-white text-slate-700 border border-slate-200 shadow hover:bg-slate-50"
            data-testid="fab-back-top"
            aria-label="Back to top"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        )}
      </div>

      {/* Mobile: bottom action bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur">
        <div className="grid grid-cols-3">
          <a href={telLink()} className="py-3 flex flex-col items-center gap-1 text-[11px] font-semibold text-slate-700 border-r border-slate-100"
             data-testid="mobile-fab-call">
            <Phone className="h-5 w-5 text-[#0A6EBD]" /> Call
          </a>
          <a href={waLink("Hello Aarogya Clinic")} target="_blank" rel="noreferrer"
             className="py-3 flex flex-col items-center gap-1 text-[11px] font-semibold text-slate-700 border-r border-slate-100"
             data-testid="mobile-fab-whatsapp">
            <MessageCircle className="h-5 w-5" style={{ color: "#25D366" }} /> WhatsApp
          </a>
          <Link to="/appointment" className="py-3 flex flex-col items-center gap-1 text-[11px] font-semibold text-white"
                style={{ background: "#0A6EBD" }} data-testid="mobile-fab-book">
            <span className="text-white text-lg leading-none">＋</span> Book
          </Link>
        </div>
      </div>
    </>
  );
}
